import { render, staticRenderFns } from "./LaudosPrazoEntrega.vue?vue&type=template&id=210d7231&"
import script from "./LaudosPrazoEntrega.vue?vue&type=script&lang=js&"
export * from "./LaudosPrazoEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports